<template>
    <div class="marketing-award-location">
        <div class="position-display">
            <span
                class="position-display-desc"
                :class="locationNameFontSize"
                :style="{ color: distanceDescColor }"
            >
                <template v-if="!isInitializedLocationPrivate">
                    点击按钮可获取位置信息
                </template>
                <template v-else-if="isInit || distance === undefined">
                    <span v-if="isInit || isInitLocationPrivate">
                        授权定位后才可参与活动哦～
                    </span>
                    <span v-else>
                        退出页面重新进入授权定位后才可参与活动哦～
                    </span>
                </template>
                <template v-else>
                    <span>
                        距离{{ locationName }} | {{ distanceDisplay }}
                    </span>
                    <span
                        v-show="!isDistanceValid"
                        class="position-display-desc-valid-tip"
                    >
                        *距离 &lt; {{ distanceValidDisplay || '--' }} 时才能领奖
                    </span>
                </template>
            </span>
            <span
                v-if="distance !== undefined"
                class="position-display-refresh"
                :class="{ 'is-disabled': isRefreshingLocation }"
                :style="{ color: refreshBtnColor }"
                @click="refreshLocation"
            >
                <span
                    v-if="isRefreshingLocation"
                    :class="{ loading: isRefreshingLocation }"
                />
                <span>刷新</span>
            </span>
        </div>
    </div>
</template>

<script>
import awardLocationMixin from '../../mixin/award-location';

export default {
    mixins: [awardLocationMixin],
    props: {
        distanceDescColor: {
            type: String,
            default: '#040b29'
        },
        refreshBtnColor: {
            type: String,
            default: '#00bebe'
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-award-location {
    margin: 20 * @layout375 20 * @layout375 20 * @layout375;
    .position-display {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14 * @layout375;
        &-desc {
            color: @text_primary;
            font-size: 14 * @layout375;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 42 * @layout375;
            &.small-font {
                font-size: 13 * @layout375;
            }
            &-valid-tip {
                font-size: 12 * @layout375;
                color: @text_tertiary;
                line-height: 18 * @layout375;
            }
        }
        &-refresh {
            position: relative;
            cursor: pointer;
            color: @text_basic_active;
            min-width: fit-content;
            height: fit-content;
            padding: 6 * @layout375;
            &.is-disabled {
                color: @text_disable !important;
                border-color: @border-divider_primary;
                cursor: not-allowed;
            }
        }
    }
}

.loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 18 * @layout375;
    width: 18 * @layout375;
    border-width: 2.5 * @layout375;
    border-style: solid;
    border-radius: 50%;
    border-color: rgba(255, 255, 255, 0.8) rgba(58, 60, 68, 0.5)
        rgba(58, 60, 68, 0.5);
    animation: rotate-right 1s linear infinite normal;
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/award/award-location.vue